import { DateCell } from "@/components/date/cell";
import TimesheetUnlockFilters from "@/modules/reports/timesheet/unlocked/filters";
import { RenderProfile } from "components/render-profile";

import List from "components/list";
import React from "react";

const UnlockedRport = () => {
  const fields = [
    "employee.id",
    "employee.first_name",
    "employee.last_name",
    "employee.avatar",
    "justification",
    "date",
  ];
  const columns = [
    {
      id: "employee",
      header: "Employee",
      accessorKey: "employee",
      cell: ({ getValue }) => <RenderProfile user={getValue()} />,
    },
    {
      id: "justification",
      header: "Justification",
      accessorKey: "justification",
    },
    { id: "date", header: "Date", accessorKey: "date", cell: DateCell },
  ];
  return (
    <List
      endPoint="timesheet_unlocks"
      title="Unlocked"
      meta={{ fields }}
      columns={columns}
      teleportFilters={true}
      showSearch={false}
      renderFilters={TimesheetUnlockFilters}
    />
  );
};

export default UnlockedRport;
